import React, { useState, useEffect } from "react";
import API from "../../api/axios";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "../layout/Layout";
import "../TeamForm/TeamForm.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

export default function TeamForm() {
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?._id || user?.id;
  console.log("User =", user);
  const [suggestions, setSuggestions] = useState([]);
  const [activeField, setActiveField] = useState(""); // which field is active
  const [savedMembers, setSavedMembers] = useState([]);
  const [serviceSuggestions, setServiceSuggestions] = useState([]);
  const [locationTypeSuggestions, setLocationTypeSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const emptyMember = {
    name: "",
    companyName: user?.companyName || "",
    employeeCode: "",
    mobile: "",
    whatsapp: "",
    email: "",
    currentLevel: "",
    upcomingLevel: "",
    dob: "",
    currentLocation: "",
    serviceLocation: [],
    whichLocation: [],
    upline: "",
    uplineName: "",
    uplineCode: "",
    saoName: "",
    saoCode: "",
    sgoName: "",
    sgoCode: "",
    ssgName: "", 
    ssgCode: "",
    referredBy: "",
    referenceCode: "",
    sameAsMobile: false, // for checkbox
  };

  const location = useLocation();
  const memberToEdit = location.state?.memberToEdit;
  const [members, setMembers] = useState(() => {
    if (memberToEdit) {


      let currentLevelRaw = memberToEdit.currentLevel || "";
      let upcomingLevel = memberToEdit.upcomingLevel || "";

      // Ensure format: "Level X"
      if (currentLevelRaw) {
        const levelNum = currentLevelRaw.toString().match(/\d+/);
        if (levelNum) {
          currentLevelRaw = `Level ${levelNum[0]}`;
        }
      }
      if (!upcomingLevel && currentLevelRaw) {
        const match = currentLevelRaw.match(/\d+/);
        const levelNum = match ? parseInt(match[0], 10) : 0;
        upcomingLevel = levelNum < 10 ? `Level ${levelNum + 1}` : "";
      }

      return [
        {
          ...emptyMember,
          ...memberToEdit,
          currentLevel: currentLevelRaw,
          upcomingLevel,
          dob: memberToEdit.dob ? new Date(memberToEdit.dob) : "",
          sameAsMobile: memberToEdit.whatsapp === memberToEdit.mobile,
          photoPreview: memberToEdit.photo || "",
        },
      ];
    } else {
      return [emptyMember];
    }
  });

const fetchContactByMobile = async (mobile, index) => {
  try {
    const res = await API.get(`/contacts/contact-by-mobile/${mobile}`);

    console.log("Response:", res.data);

    if (!res.data.success) return;

    const contact = res.data.data;

    const updated = [...members];

    updated[index] = {
      ...updated[index],
      name: `${contact.firstName || ""} ${contact.lastName || ""}`.trim(),
      mobile: contact.mobile || "",
      whatsapp: contact.whatsappNumber || "",
      email: contact.email || "",
      currentLocation: contact.currentLocation || "",
      serviceLocation: contact.workLocation || [],
      whichLocation: contact.whichLocation || [],
      upline: contact.upline || "",
      uplineName: contact.uplineName || "",
      uplineCode: contact.uplineCode || "",
      saoName: contact.saoName || "",
      saoCode: contact.saoCode || "",
      sgoName: contact.sgoName || "",
      sgoCode: contact.sgoCode || "",
      ssgName: contact.ssgName || "",
      ssgCode: contact.ssgCode || "",
      referredBy: contact.referredBy || "",
      referenceCode: contact.referenceCode || "",
    };

    setMembers(updated);
  } catch (err) {
    console.log(err.response?.data);
  }
};


  const [errors, setErrors] = useState([{}]);

  const handleChange = (index, e) => {
    const updated = [...members];
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      updated[index][name] = checked;
      if (name === "sameAsMobile") {
        updated[index].whatsapp = checked ? updated[index].mobile : "";
      }
    } else {
      updated[index][name] = value;
      if (updated[index].sameAsMobile) {
        updated[index].whatsapp = updated[index].mobile;
      }
    }
    setMembers(updated);
  };


  const addMember = () => {
    setMembers([...members, { ...emptyMember }]);
    setErrors([...errors, {}]);
  };

  const removeMember = (index) => {
    const updated = members.filter((_, i) => i !== index);
    setMembers(updated);
    const updatedErrors = errors.filter((_, i) => i !== index);
    setErrors(updatedErrors);
  };

  const validateMember = (member) => {
    const errs = {};

    // Full Name
    if (!member.name) errs.name = "Full Name is required";

    // Mobile number: exactly 10 digits, only numbers
    if (!member.mobile) {
      errs.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(member.mobile)) {
      errs.mobile = "Mobile number must be exactly 10 digits";
    }

    // Whatsapp number: exactly 10 digits
    if (!member.whatsapp) {
      errs.whatsapp = "Whatsapp number is required";
    } else if (!/^\d{10}$/.test(member.whatsapp)) {
      errs.whatsapp = "Whatsapp number must be exactly 10 digits";
    }

    // Email validation
    if (!member.email) {
      errs.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(member.email)
    ) {
      errs.email = "Invalid email address";
    }

    // Level validations
    if (!member.currentLevel) errs.currentLevel = "Current Level is required";
    if (!member.upcomingLevel) errs.upcomingLevel = "Upcoming Level is required";

    // DOB validation
    if (!member.dob) errs.dob = "Date of Birth is required";

   
    // Location validation: at least one required
   if (
  !member.currentLocation &&
  (!member.serviceLocation || member.serviceLocation.length === 0) &&
  (!member.whichLocation || member.whichLocation.length === 0)
) {
  errs.location = "At least one location is required";
}
    // Upline validations
    if (!member.upline) errs.upline = "Select Upline";
    if (!member.uplineName) errs.uplineName = "Upline Name is required";
    if (!member.uplineCode) errs.uplineCode = "Upline Code is required";
   // R1 -> Only SAO
if (member.upline === "R1") {
  if (!member.saoName?.trim()) {
    errs.saoName = "SAO Name is required";
  }

  if (!member.saoCode?.trim()) {
    errs.saoCode = "SAO Code is required";
  }
}

// R2 -> SAO + SGO
if (member.upline === "R2") {
  if (!member.saoName?.trim()) {
    errs.saoName = "SAO Name is required";
  }

  if (!member.saoCode?.trim()) {
    errs.saoCode = "SAO Code is required";
  }

  if (!member.sgoName?.trim()) {
    errs.sgoName = "SGO Name is required";
  }

  if (!member.sgoCode?.trim()) {
    errs.sgoCode = "SGO Code is required";
  }
}

// R3 -> SAO + SGO + SSG
if (member.upline === "R3") {
  if (!member.saoName?.trim()) {
    errs.saoName = "SAO Name is required";
  }

  if (!member.saoCode?.trim()) {
    errs.saoCode = "SAO Code is required";
  }

  if (!member.sgoName?.trim()) {
    errs.sgoName = "SGO Name is required";
  }

  if (!member.sgoCode?.trim()) {
    errs.sgoCode = "SGO Code is required";
  }

  if (!member.ssgName?.trim()) {
    errs.ssgName = "SSG Name is required";
  }

  if (!member.ssgCode?.trim()) {
    errs.ssgCode = "SSG Code is required";
  }
}

// Reference
if (!member.referredBy?.trim()) {
  errs.referredBy = "Reference Name is required";
}

// SSG (only for R3)
if (member.upline === "R3") {
  if (!member.ssgName?.trim()) {
    errs.ssgName = "SSG Name is required";
  }

  if (!member.ssgCode?.trim()) {
    errs.ssgCode = "SSG Code is required";
  }
}

if (!member.referenceCode?.trim()) {
  errs.referenceCode = "Company Code is required";
}

// Added By (extra safety)
if (!user?.name) {
  errs.addedBy = "Added By is missing";
}



    return errs;
  };


  const selectServiceLocation = (place, index) => {
    const updated = [...members];

    if (!updated[index].serviceLocation.includes(place.city)) {
      updated[index].serviceLocation = [
        ...updated[index].serviceLocation,
        place.city,
      ];
    }

    setMembers(updated);

    // CLOSE DROPDOWN
    setServiceSuggestions([]);
    setActiveField("");
  };
let debounceTimer;

const searchLocationType = (query, index) => {
  clearTimeout(debounceTimer);

  debounceTimer = setTimeout(async () => {
    if (!query || query.length < 2) {
      setLocationTypeSuggestions([]);
      return;
    }

    try {
      const res = await fetch(`https://photon.komoot.io/api/?q=${query}&limit=10`);
      const data = await res.json();

      const uniqueCities = [
        ...new Set(
          data.features
            .filter((item) => item.properties.country === "India")
            .map(
              (item) =>
                item.properties.city ||
                item.properties.name ||
                item.properties.state ||
                ""
            )
            .filter((city) => city !== "")
        ),
      ];

      const cities = uniqueCities.map((city) => ({ city }));

      setLocationTypeSuggestions(cities);
      setActiveField({ name: "whichLocation", index });

    } catch (error) {
      console.log(error);
    }
  }, 400); // delay 400ms
};

const selectLocationType = (place, index) => {
  const updated = [...members];

  // ✅ limit check FIRST
  if (updated[index].whichLocation.length >= 5) {
    showToast("You can select maximum 5 locations only", "danger");
    return;
  }

  // ✅ duplicate check
  if (updated[index].whichLocation.includes(place.city)) {
    showToast("Location already selected", "danger");
    return;
  }

  updated[index].whichLocation = [
    ...updated[index].whichLocation,
    place.city
  ];

  updated[index].whichLocationInput = "";

  setMembers(updated);
  setLocationTypeSuggestions([]);
  setActiveField("");
};

  const removeLocationType = (index, city) => {
    const updated = [...members];

    updated[index].whichLocation =
      updated[index].whichLocation.filter((loc) => loc !== city);

    setMembers(updated);
  };
  const searchLocation = async (query, field) => {
    if (!query || query.length < 2) {
      setSuggestions([]);
      return;
    }

    try {
      const res = await fetch(`https://photon.komoot.io/api/?q=${query}&limit=10`);
      const data = await res.json();

      const cities = data.features
        .filter((item) => item.properties.country === "India")
        .map((item) => ({
          city:
            item.properties.city ||
            item.properties.name ||
            item.properties.state ||
            "",
        }))
        .filter((item) => item.city !== "");

      setSuggestions(cities);
      setActiveField(field);
    } catch (error) {
      console.log(error);
    }
  };

  const searchServiceLocation = async (query, index) => {
    if (!query || query.length < 2) {
      setServiceSuggestions([]);
      return;
    }

    try {
      const res = await fetch(`https://photon.komoot.io/api/?q=${query}&limit=10`);
      const data = await res.json();

      const cities = data.features
        .filter((item) => item.properties.country === "India")
        .map((item) => ({
          city:
            item.properties.city ||
            item.properties.name ||
            item.properties.state ||
            "",
        }))
        .filter((item) => item.city !== "");

      setServiceSuggestions(cities);
      setActiveField({ name: "serviceLocation", index });
    } catch (error) {
      console.log(error);
    }
  };

  const removeServiceLocation = (index, city) => {
    const updated = [...members];
    updated[index].serviceLocation = updated[index].serviceLocation.filter(
      (loc) => loc !== city
    );
    setMembers(updated);
  };


  

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const res = await API.get(`/team/all/${userId}`);
        setSavedMembers(res.data.teamMembers);
      } catch (error) {
        console.error(error);
      }
    };
    fetchTeamMembers();
  }, [userId]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = members.map((member) => validateMember(member));
    setErrors(newErrors);

    if (newErrors.some(err => Object.keys(err).length > 0)) {
      const firstError = newErrors.find(err => Object.keys(err).length > 0);
      showToast(Object.values(firstError)[0], "danger");
      return;
    }

    try {
      setLoading(true);

      for (let member of members) {
        const formData = new FormData();

        for (let key in member) {
          if (key === "photoFile" && member[key]) {
            formData.append("photo", member[key]);
          } else {
            formData.append(key, member[key]);
          }
        }

        if (member._id) {
          await API.put(`/team/update/${userId}/${member._id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        } else {
          await API.post(`/team/add/${userId}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }
      }

      showToast("Team Members Saved Successfully", "success");

      setTimeout(() => {
        navigate("/team-view");   // 👈 Redirect here
      }, 1500);

    } catch (err) {
      console.error(err);
      showToast("Failed to save team members", "danger");
    } finally {
      setLoading(false);
    }
  };
  const selectLocation = (place) => {
    const updated = [...members];
    updated[activeField.index][activeField.name] = place.city;
    setMembers(updated);
    setSuggestions([]);
    setActiveField("");
  };

const getUplineOptions = (relationType) => {
  switch (relationType) {
    case "R1":
      return ["SAO"];
    case "R2":
      return ["SAO", "SGO"];
    case "R3":
      return ["SAO", "SGO", "SSG"];
    default:
      return [];
  }
};
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success", // or "danger" for errors
  });

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast((prev) => ({ ...prev, show: false }));
    }, 3000); // hide after 3 seconds
  };

  return (
    <Layout>
      <div className="container  position-relative">
        {toast.show && (
          <div
            className={`toast align-items-center text-bg-${toast.type} position-absolute top-0 end-0 m-3 show`}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{ zIndex: 1000 }}
          >
            <div className="d-flex">
              <div className="toast-body">{toast.message}</div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 m-auto"
                onClick={() => setToast({ ...toast, show: false })}
              ></button>
            </div>
          </div>
        )}


      </div>
      <div className="container py-5">
        <div className="team-card">
          <div className="team-header">
            <div className="team-header">
              <h3>
                {memberToEdit ? "✏️ Update Team Member" : "👥 Add Team Member"}
              </h3>
              <p>Build and manage your network team</p>
            </div>

          </div>

          <div className="team-body">
            <form className="team-form" onSubmit={handleSubmit}>
              {members.map((member, index) => (
                <div key={index} className="member-card">
                  <div className="member-top">
                    <h5>Member #{index + 1}</h5>
                    {members.length > 1 && (
                      <button
                        type="button"
                        className="remove-btn"
                        onClick={() => removeMember(index)}
                      >
                        Remove
                      </button>
                    )}
                  </div>

                  <h6 className="section-title">Basic Details</h6>


                  {/* PROFILE IMAGE CENTER */}
                  <div className="row mb-4">
                    <div className="col-12 text-center">
                      <div className="photo-upload mx-auto">

                        {member.photoPreview ? (
                          <img
                            src={member.photoPreview}
                            alt="Preview"
                            className="photo-preview"
                          />
                        ) : (
                          <div className="upload-placeholder">
                            📷 Upload Photo
                          </div>
                        )}

                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
  const file = e.target.files[0];
  const updated = [...members];
  const updatedErrors = [...errors];

  if (file) {
    if (file.size > 1024 * 1024) {
      updatedErrors[index].photo = "Image must be less than 1MB";
      setErrors(updatedErrors);
      return;
    }

    updated[index].photoFile = file;
    updated[index].photoPreview = URL.createObjectURL(file);

    // remove error if fixed
    delete updatedErrors[index].photo;
    setErrors(updatedErrors);
  }

  setMembers(updated);
}}
                        />
                        

                      </div>
                      {errors[index]?.photo && (
  <small className="text-danger d-block mt-2">
    {errors[index].photo}
  </small>
)}
                    </div>
                  </div>

                  <div className="row g-3">

                    <div className="col-md-4">

                      <label className="form-label-modern">Full Name</label>

                      <input
                        type="text"
                        name="name"
                        className="modern-input"
                        value={member.name}
                        onChange={(e) => handleChange(index, e)}
                      />

                      {errors[index]?.name && (
                        <small className="text-danger">{errors[index].name}</small>
                      )}

                    </div>

                    <div className="col-md-4">


                      <label className="form-label-modern">Company Name</label>
                      <input
                        type="text"
                        name="companyName"
                        className="modern-input"
                        value={member.companyName}
                        readOnly
                      />



                    </div>

                    <div className="col-md-4">
                      <label className="form-label-modern">Company Code</label>
                      <input
                        type="text"
                        name="employeeCode"
                        className="modern-input"
                        value={member.employeeCode}
                        onChange={(e) => handleChange(index, e)}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label-modern">Mobile Number</label>
                     <input
  name="mobile"
  className="modern-input"
  value={member.mobile}
  onChange={(e) => {
    handleChange(index, e);

    const value = e.target.value;

    if (/^\d{10}$/.test(value)) {
      fetchContactByMobile(value, index);
    }
  }}
/>
                      {errors[index]?.mobile && (
  <small className="text-danger">{errors[index].mobile}</small>
)}
                    </div>

                    <div className="col-md-4">

                      <label className="form-label-modern">Whatsapp Number</label>

                      <input
                        type="text"
                        name="whatsapp"
                        className="modern-input"
                        value={member.whatsapp}
                        onChange={(e) => handleChange(index, e)}
                      />

                      {errors[index]?.whatsapp && (
                        <small className="text-danger">{errors[index].whatsapp}</small>
                      )}

                      <div className="form-check mt-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="sameAsMobile"
                          checked={member.sameAsMobile}
                          onChange={(e) => handleChange(index, e)}
                          id={`sameMobile${index}`}
                        />
                        <label
                          className="form-check-label text-start d-block"
                          htmlFor={`sameMobile${index}`}
                        >
                          Same as Mobile
                        </label>
                      </div>

                    </div>

                    <div className="col-md-4">

                      <label className="form-label-modern">Email</label>

                      <input
                        type="email"
                        name="email"
                        className="modern-input"
                        value={member.email}
                        onChange={(e) => handleChange(index, e)}
                      />

                      {errors[index]?.email && (
                        <small className="text-danger">{errors[index].email}</small>
                      )}

                    </div>

                    <div className="col-md-4">

                      <label className="form-label-modern">Current Level</label>

                      <select
                        name="currentLevel"
                        className="modern-input"
                        value={member.currentLevel}
                        onChange={(e) => {
                          const updated = [...members];
                          updated[index].currentLevel = e.target.value;

                          // Auto-fill upcomingLevel
                          if (e.target.value) {
                            const levelNum = parseInt(e.target.value.split(" ")[1], 10);
                            const nextLevel = levelNum < 10 ? `Level ${levelNum + 1}` : "";
                            updated[index].upcomingLevel = nextLevel;
                          } else {
                            updated[index].upcomingLevel = "";
                          }

                          setMembers(updated);
                        }}
                      >
                        <option value="">Select Current Level</option>
                        {Array.from({ length: 10 }, (_, i) => (
                          <option key={i + 1} value={`Level ${i + 1}`}>
                            Level {i + 1}
                          </option>
                        ))}
                      </select>

                      {errors[index]?.currentLevel && (
                        <small className="text-danger">{errors[index].currentLevel}</small>
                      )}

                    </div>


                    <div className="col-md-4">

                      <label className="form-label-modern">Upcoming Level</label>

                      <input
                        name="upcomingLevel"
                        className="modern-input"
                        value={member.upcomingLevel}
                        readOnly
                      />

                      {errors[index]?.upcomingLevel && (
                        <small className="text-danger">{errors[index].upcomingLevel}</small>
                      )}

                    </div>


                    <div className="col-md-4">

                      <label className="form-label-modern">Date of Birth</label>

                      <DatePicker
                        selected={member.dob ? new Date(member.dob) : null}
                        onChange={(date) =>
                          handleChange(index, {
                            target: {
                              name: "dob",
                              value: date ? date.toISOString().split("T")[0] : "",
                            },
                          })
                        }
                        className="modern-input"
                        dateFormat="dd-MM-yyyy"
                      />

                      {errors[index]?.dob && (
                        <small className="text-danger">{errors[index].dob}</small>
                      )}

                    </div>
                  </div>








                  <h6 className="section-title">Location Details</h6>

                  <div className="row g-3">

                    {/* Current Location */}
                    <div className="col-md-4" style={{ position: "relative" }}>
                      <label className="form-label-modern">Current Location</label>

                      <input
                        name="currentLocation"
                        className="modern-input"
                        value={member.currentLocation}
                        onChange={(e) => {
                          handleChange(index, e);
                          searchLocation(e.target.value, { name: "currentLocation", index });
                        }}
                        autoComplete="off"
                      />

                      {suggestions.length > 0 &&
                        activeField.name === "currentLocation" &&
                        activeField.index === index && (
                          <ul className="suggestion-list">
                            {suggestions.map((place, i) => (
                              <li key={i} onClick={() => selectLocation(place)}>
                                {place.city}
                              </li>
                            ))}
                          </ul>
                        )}
                    </div>


                    {/* Service Location */}
                    <div className="col-md-4" style={{ position: "relative" }}>

                      <label className="form-label-modern">Service Location</label>

                      <input
                        className="modern-input"
                        placeholder="Search City"
                        onChange={(e) => searchServiceLocation(e.target.value, index)}
                      />

                      {/* Selected Cities */}
                      <div className="selected-locations">
                        {member.serviceLocation.map((city, i) => (
                          <span key={i} className="location-tag">
                            {city}
                            <button
                              type="button"
                              onClick={() => removeServiceLocation(index, city)}
                            >
                              ×
                            </button>
                          </span>
                        ))}
                      </div>

                      {/* Suggestions */}
                      {serviceSuggestions.length > 0 &&
                        activeField.name === "serviceLocation" &&
                        activeField.index === index && (

                          <ul className="suggestion-list">
                            {serviceSuggestions.map((place, i) => (
                              <li key={i} onClick={() => selectServiceLocation(place, index)}>
                                {place.city}
                              </li>
                            ))}
                          </ul>

                        )}

                    </div>


                    {/* Which Location */}
                   <div className="col-md-4" style={{ position: "relative" }}>
  <label className="form-label-modern">Wish Location</label>

  <input
    className="modern-input"
    placeholder="Search Location"
    value={member.whichLocationInput || ""}
    disabled={member.whichLocation.length >= 5} // ✅ disable after 5
    onChange={(e) => {
      const value = e.target.value;
      const updated = [...members];

      // 🚫 stop typing after 5
      if (updated[index].whichLocation.length >= 5) {
        showToast("Only 5 locations allowed", "danger");
        return;
      }

      updated[index].whichLocationInput = value;
      setMembers(updated);

      searchLocationType(value, index);
    }}
  />

  {/* Selected Locations */}
  <div className="selected-locations">
    {member.whichLocation.map((city, i) => (
      <span key={i} className="location-tag">
        {city}
        <button
          type="button"
          onClick={() => removeLocationType(index, city)}
        >
          ×
        </button>
      </span>
    ))}
  </div>

  {member.whichLocation.length === 5 && (
  <small className="text-danger mt-2 d-block">
    Only 5 locations allowed (5/5 selected)
  </small>
)}

  {/* Suggestions */}
  {member.whichLocation.length < 5 &&
    locationTypeSuggestions.length > 0 &&
    activeField.name === "whichLocation" &&
    activeField.index === index && (
      <ul className="suggestion-list">
        {locationTypeSuggestions.map((place, i) => (
          <li key={i} onClick={() => selectLocationType(place, index)}>
            {place.city}
          </li>
        ))}
      </ul>
    )}
</div>


                    {/* Location Error */}
                    {errors[index]?.location && (
                      <div className="col-12">
                        <small className="text-danger">{errors[index].location}</small>
                      </div>
                    )}

                  </div>
                  {/* UPLINE */}

                  <h6 className="section-title">Hierarchy Details</h6>

                  <div className="row g-3">



<div className="card mt-4">
  <div className="card-header fw-bold">
    <i className="fas fa-users me-2"></i> Team Details
  </div>

  <div className="card-body p-0">
    <table className="table table-bordered mb-0 align-middle">
      <thead className="table-light text-center">
        <tr>
          <th width="28%">Relationship</th>
          <th width="47%">Name</th>
          <th width="25%">Code</th>
        </tr>
      </thead>

      <tbody>

        {/* Upline */}
        <tr>
          <td>
            <label className="mb-2 d-block">Upline</label>

            <select
              className="form-select"
              name="upline"
              value={member.upline}
              onChange={(e) => handleChange(index, e)}
            >
              <option value="">Select</option>
              <option value="R1">R1</option>
              <option value="R2">R2</option>
            </select>
          </td>

          <td>
            <input
              type="text"
              className="form-control"
              name="uplineName"
              placeholder="Enter Upline Name"
              value={member.uplineName}
              onChange={(e) => handleChange(index, e)}
            />
          </td>

          <td>
            <input
              type="text"
              className="form-control"
              name="uplineCode"
              placeholder="Enter Upline Code"
              value={member.uplineCode}
              onChange={(e) => handleChange(index, e)}
            />
          </td>
        </tr>

        {/* Downline SAO */}
        <tr>
          <td className="text-center">
            Downline SAO
          </td>

          <td>
            <input
              type="text"
              className="form-control"
              name="saoName"
              placeholder="Enter SAO Name"
              value={member.saoName}
              onChange={(e) => handleChange(index, e)}
            />
          </td>

          <td>
            <input
              type="text"
              className="form-control"
              name="saoCode"
              placeholder="Enter SAO Code"
              value={member.saoCode}
              onChange={(e) => handleChange(index, e)}
            />
          </td>
        </tr>

        {/* Downline SGO */}
        <tr>
          <td className="text-center">
            Downline SGO
          </td>

          <td>
            <input
              type="text"
              className="form-control"
              name="sgoName"
              placeholder="Enter SGO Name"
              value={member.sgoName}
              onChange={(e) => handleChange(index, e)}
            />
          </td>

          <td>
            <input
              type="text"
              className="form-control"
              name="sgoCode"
              placeholder="Enter SGO Code"
              value={member.sgoCode}
              onChange={(e) => handleChange(index, e)}
            />
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</div>
</div>

                  {/* EXTRA */}

                  <h6 className="section-title">Alternative Details</h6>

                  <div className="row g-3">

                    {/* Reference Name */}
                    <div className="col-md-4">
                      <label className="form-label-modern">Reference Name</label>
                      <input
                        name="referredBy"
                        className="modern-input"
                        value={member.referredBy}
                        onChange={(e) => handleChange(index, e)}
                      />
                      {errors[index]?.referredBy && (
  <small className="text-danger">{errors[index].referredBy}</small>
)}
                    </div>

                    {/* Company Code */}
                    <div className="col-md-4">
                      <label className="form-label-modern">Company Code</label>
                      <input
                        name="referenceCode"
                        className="modern-input"
                        value={member.referenceCode || ""}
                        onChange={(e) => handleChange(index, e)}
                      />
                      {errors[index]?.referenceCode && (
  <small className="text-danger">{errors[index].referenceCode}</small>
)}
                    </div>

                    {/* Added By */}
                    <div className="col-md-4">
                      <label className="form-label-modern">Added By</label>
                      <input
                        className="modern-input"
                        value={user?.name}
                        readOnly
                      />
                    </div>

                  </div>

                </div>
              ))}

              <div className="form-buttons mt-4">
                <button
                  type="button"
                  className="btn-add-member me-2"
                  onClick={addMember}
                >
                  + Add Another Member
                </button>

                <button
                  type="submit"
                  className="btn-submit-team"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Saving...
                    </>
                  ) : (
                    "Submit Team Members"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
}